import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import ModalDialog from 'garaje/components/ui/classic/modal-dialog';

<template>
  <ModalDialog
    @clickOutsideToClose={{false}}
    @targetAttachment="center"
    @translucentOverlay={{true}}
    @containerClass="ember-modal-dialog--gdpr-integrations"
  >
    <div class="p-8">
      <button
        type="button"
        aria-label="Close"
        data-test-close-modal
        {{on "click" (fn (mut @modalVisible) false)}}
        class="btn btn--small btn--outline btn--cancel float-right -mt-2"
      >
        &times;
      </button>
      <h2 class="mb-4">GDPR notice</h2>
      <p>Companies that are subject to GDPR requirements and choose to install integrations should confirm that each
        integration partner complies with GDPR independently of Envoy.</p>
    </div>
  </ModalDialog>
</template> satisfies TOC<{
  Args: {
    modalVisible: boolean;
  };
}>;
